import {
  getContextQueryVariables,
  getContextFilterClientExports,
  getContextFiltersQueryArguments,
} from '../../../utils/helpers/contextFilters';

const overrides = { gameIds: false };

export const getPlayersStats = (category) => {
  const cat1StatNames = category?.map((m) => m.name) || [];
  const joinedStatNames = cat1StatNames.join('\n');
  return `
    query GetPlayersStats(
      $competitionId: Int!
      $seasonId: Int!
      $teamIds: [Int!]
      $groupByMode: [PlayerStatGroupBy!]
      $orderBy: [StatOrderBy!]
      $playerName: String
      $ncaaTransferPortal: Boolean
      $minPlays: Int
      $rosterPositions: [GeneralPosition!]
      ${getContextQueryVariables(overrides)}
    ) {
      ${getContextFilterClientExports(overrides)}
      playerStats(
        playFilters: {
          competitionId: $competitionId
          seasonId: $seasonId
          ${getContextFiltersQueryArguments(overrides)}
        }
        playerStatFilters: {
          teamIds: $teamIds
          playerName: $playerName
          ncaaTransferPortal: $ncaaTransferPortal
          minPlays: $minPlays
          rosterPositions: $rosterPositions
        }
        groupBy: $groupByMode
        orderBy: $orderBy
      ) {
        items {
          groups {
            key
            value
          }
          plays
          playerName
          rosterPosition
          teamName
          teamShortName
          playPosition
          jerseyNumber
          ${joinedStatNames}
        }
        }
      }
  `;
};
